import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { apiReparacionesInstance, authHeaderReparaciones } from "../../redux/actions/reparaciones/reparaciones";

import { Form, Input, Select, Button, Row, Col, Typography, Space, InputNumber, DatePicker } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearReparacionPage() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [clientes, setClientes] = useState([]);

  useEffect(() => {
    apiReparacionesInstance.get("/clientes", { headers: authHeaderReparaciones() })
      .then((r) => setClientes((r.data?.items ?? []).map((c) => ({ label: c.nombre, value: c.id_cliente }))))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      id_cliente: values.id_cliente,
      tipo_aparato: values.tipo_aparato.trim(),
      marca: values.marca?.trim() || null,
      modelo: values.modelo?.trim() || null,
      numero_serie: values.numero_serie?.trim() || null,
      falla_reportada: values.falla_reportada.trim(),
      accesorios_dejados: values.accesorios_dejados?.trim() || null,
      fecha_prometida: values.fecha_prometida ? values.fecha_prometida.format("YYYY-MM-DD") : null,
      anticipo: values.anticipo ?? null,
    };

    setSaving(true);
    try {
      const { data } = await apiReparacionesInstance.post("/reparaciones", payload, { headers: authHeaderReparaciones() });
      toast.success(`Equipo recibido con folio ${data.item.numero_trabajo}`);
      navigate(`/app/reparaciones/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al registrar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>Recibir equipo</Title>
            <Text className="eventos-subtitle">Registra los datos del equipo recibido para su reparacion.</Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/reparaciones")} disabled={saving}>Cancelar</Button>
            <Button type="primary" loading={saving} icon={<i className="fa-solid fa-plus" />} onClick={handleSave} style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}>
              Recibir equipo
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical">
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-screwdriver-wrench"></i></span>
              Datos del equipo
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="id_cliente" label={<span className="paq-field-label">Cliente</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Select placeholder="Selecciona cliente" options={clientes} showSearch optionFilterProp="label" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="tipo_aparato" label={<span className="paq-field-label">Tipo de aparato</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Input placeholder="Ej. Laptop, impresora, bocina..." autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={8}>
                <Form.Item name="marca" label={<span className="paq-field-label">Marca (opcional)</span>}>
                  <Input autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="modelo" label={<span className="paq-field-label">Modelo (opcional)</span>}>
                  <Input autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="numero_serie" label={<span className="paq-field-label">Numero de serie (opcional)</span>}>
                  <Input autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item name="falla_reportada" label={<span className="paq-field-label">Falla reportada</span>} rules={[{ required: true, message: "Requerido" }]}>
                  <Input.TextArea rows={3} placeholder="Descripcion del problema reportado por el cliente..." />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item name="accesorios_dejados" label={<span className="paq-field-label">Accesorios dejados (opcional)</span>}>
                  <Input placeholder="Ej. Cargador, funda, mouse..." autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item name="fecha_prometida" label={<span className="paq-field-label">Fecha prometida (opcional)</span>}>
                  <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" disabledDate={(d) => d && d < dayjs().startOf("day")} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="anticipo" label={<span className="paq-field-label">Anticipo (opcional)</span>}>
                  <InputNumber style={{ width: "100%" }} min={0} precision={2} placeholder="0.00" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </main>
  );
}
